import React, { memo } from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ListGroup, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSortAmountDown } from '@fortawesome/free-solid-svg-icons';

import FieldListItem from './FieldListItem';
import { Field, LayerVisibility } from '../../../../types/types';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../../providers/AppProvider';
import { useRouteMatch } from 'react-router';
import LayerVisibilityControlPanel from '../LayerVisibilityControlPanel';

import { List, AutoSizer } from "react-virtualized";
import FieldFilter from './FieldFilter';
import { useFieldStore } from '../../providers/FieldProvider';
import FieldListHeader from './FieldListHeader';
import { LoadingSpinner } from '../../../../../../components/LoadingSpinner';
import { FieldSort } from './FieldSort';
import { SETTING_SEASON_YEAR } from '../../../../utils/settings';

type FieldListProps = {
  title: string,
  fields: Field[] | null,
  selectedId: number | null,
  showActions?: boolean,
  showAdd?: boolean,
  onSelectField: Function,
  onHoverField: Function,
  overlayVisibility: LayerVisibility[],
  setOverlayVisible: (v: LayerVisibility[]) => void,
  dateSelectorParameters?: any | null, 
  setDateSelectorParameters?: Function | null,
  dateIndexSelected?: Array<number> | null,
  setDateIndexSelected?: Function | null,
  dateSelected: string | null,
};

const FIELD_APP_URL = process.env.REACT_APP_FIELD_MGR_ROOT_URL;

const FieldList = ({dateSelected, title, fields, selectedId, showActions=true, showAdd=true, onHoverField, onSelectField, overlayVisibility, setOverlayVisible, dateSelectorParameters=null, setDateSelectorParameters=null, dateIndexSelected=null, setDateIndexSelected=null} : FieldListProps) => {
  const { state, settings, updateSettings } = useStore();
  const { isFiltered, isFieldLoading, sortedBy, updateDate } = useFieldStore();
  // use this to create the links.
  const match = useRouteMatch(`${FIELD_APP_URL}/:vp/fields/`);

  const [fieldList, setFieldList] = useState<Field[] | null>(null);
  const [totalArea, setTotalArea] = useState<number | null>(null);
  const [selectedFieldId, setSelectedFieldId] = useState<number | null>(null);
  const [scrollToIndex, setScrollToIndex] = useState<number | null>(null);
  const [showFilters, setShowFilters] = useState(false);
  const [showSorts, setShowSorts] = useState(false);

  const history = useHistory();


  useEffect(() => {
    console.log("B021324 SETTING_SEASON_YEAR, settings[SETTING_SEASON_YEAR]", SETTING_SEASON_YEAR, settings[SETTING_SEASON_YEAR])
    updateSettings(SETTING_SEASON_YEAR, settings[SETTING_SEASON_YEAR]);
  },[])

  useEffect(() => {
    // make sure the fields have a crop defined.
    let newFields = fields ? [...fields] : null;

    if(newFields) {
      newFields.map(item => {
        item.crop = state.crops.find(c => c.id === item.crop_id)
      });
    }

    setFieldList(newFields);
  }, [fields]);

  useEffect(() => {
    console.log("072825 fieldList", fieldList);
    if (fieldList) {
      const _totalArea = fieldList.reduce((sum, field) => sum + (field.area ?? 0), 0);
      console.log("072825 Total Area:", _totalArea);
      setTotalArea(_totalArea);
    }
  }, [fieldList]);

  useEffect(() => {
      updateDate(dateSelected);
  }, [dateSelected]);

  useEffect(() => {
    setSelectedFieldId(selectedId);

    const index = fieldList?.findIndex((f: Field) => f.id === selectedId);

    if(index !== undefined && index !== -1) {
      setScrollToIndex(index);
    }

  }, [selectedId]);

  const onFieldClick = (field: Field) => {
    onSelectField(field);
  }

  const onMouseEnter = (field: Field) => {
    onHoverField(field);
  }

  const onMouseLeave = (field: Field) => {
    onHoverField(null);
  }

  const onEditClicked = (field: Field) => {
    if(match) {
      //onSelectField(field);
      history.push(`${match.url}/${field.id}/edit`);
    }
  }

  const renderRow = ({ index, key, style }: any) => {
    const field = fieldList![index];
    //console.log("B071024 A field", field);
    return (
      <ListGroup.Item style={style} key={field.id} className="ls-list-group px-3 rounded-0" action variant="light" active={selectedFieldId !== null && selectedFieldId === field.id ? true : false }
                      onMouseEnter={() => onMouseEnter(field)}
                      onMouseLeave={() => onMouseLeave(field)}
                      onClick={() => onFieldClick(field)}>
        <FieldListItem 
          item={field} 
          sort={sortedBy} 
          onClick={onEditClicked} 
          actions={showActions} 
          dateIndexSelected={dateIndexSelected}
          dateSelected={dateSelected}
          dateSelectorParameters={dateSelectorParameters}
        />
      </ListGroup.Item>
    );
  }

  return (
    <div className="field-list d-flex flex-column h-100">
      <div className="align-items-start d-flex justify-content-between px-2 py-3">
        <h3 className="m-0 ml-2 text-lg font-weight-bold">{title}</h3>
        <div className="d-flex">
          <div
            onClick={(e: any) => {
              setShowFilters(prevState => {
                return !prevState;
              });
            }}
            className="d-flex align-items-center mr-3"
            style={{cursor: 'pointer'}}
            title={`${isFiltered ? 'Blocks are filtered' : 'No filter applied'}`}>
            <FontAwesomeIcon className={`text-sm ${isFiltered ? 'text-info' : ''}`} icon="filter" />
          </div>
          <div
            onClick={(e: any) => {
              setShowSorts(prevState => {
                return !prevState;
              });
            }}
            className="d-flex align-items-center mr-3"
            style={{cursor: 'pointer'}}
            title="Sort blocks">
            <FontAwesomeIcon className="text-sm" icon={faSortAmountDown} />
          </div>
        </div>
      </div>

      { showFilters && <FieldFilter onCancel={() => setShowFilters(false)} /> }

      { showSorts && <FieldSort onCancel={() => {
        setShowSorts(false);
        setScrollToIndex(0);
      }} /> }
      {/*<LayerVisibilityControlPanel 
        showDatePicker={true} 
        layers={overlayVisibility} 
        onChange={(visibility: LayerVisibility[]) => setOverlayVisible(visibility)} 
        context={"sidebar"}
        dateSelectorParameters={dateSelectorParameters}
        setDateSelectorParameters={setDateSelectorParameters} 
        dateIndexSelected={dateIndexSelected}
        setDateIndexSelected={setDateIndexSelected}
      />*/}
      <FieldListHeader totalArea={totalArea} fieldCount={fieldList ? fieldList.length : 0} isFiltered={isFiltered} />

      {!isFieldLoading ?
        <div className="flex-grow-1 p-0">
          <AutoSizer>
            {({height, width}: any) => (
              <ListGroup>
                <List
                  width={width}
                  height={height}
                  rowHeight={70}
                  rowRenderer={renderRow}
                  rowCount={fieldList ? fieldList.length : 0}
                  scrollToIndex={scrollToIndex ?? 0}
                  overscanRowCount={3} />
              </ListGroup>)}
          </AutoSizer>
        </div>
        : <div className="flex-grow-1 p-0 d-flex justify-content-center"><LoadingSpinner message="Loading blocks..."></LoadingSpinner></div>
      }

      { showAdd &&
      <div className="border p-3">
        <Dropdown drop="up">
          <Dropdown.Toggle
            variant="success"
            id="add-field"
            className="w-100"
          >
            <FontAwesomeIcon icon={faPlus} /> Add Block
          </Dropdown.Toggle>
          <Dropdown.Menu className="shadow w-100">
            { match &&
            <>
              <Dropdown.Item as={Link} to={`${match.url}/new`}>Draw</Dropdown.Item>
              <Dropdown.Item as={Link} to={`${match.url}/select`}>Select</Dropdown.Item>
              <Dropdown.Item as={Link} to={`${match.url}/import`}>Import</Dropdown.Item>
            </>
            }
          </Dropdown.Menu>
        </Dropdown>
      </div>
      }
    </div>
  );
}

export default memo(FieldList);
